// extracted by mini-css-extract-plugin
export var activeFooter = "Betslip-module--activeFooter--156ae";
export var back = "Betslip-module--back--231d7";
export var button = "Betslip-module--button--5cc00";
export var buttons = "Betslip-module--buttons--a2b55";
export var clamp = "Betslip-module--clamp--16b35";
export var close = "Betslip-module--close--4c88e";
export var container = "Betslip-module--container--082a6";
export var content = "Betslip-module--content--9cc3f";
export var entriesTab = "Betslip-module--entriesTab--f92ca";
export var eventName = "Betslip-module--eventName--43dbb";
export var exoticTitle = "Betslip-module--exoticTitle--6e79e";
export var footer = "Betslip-module--footer--8906f";
export var header = "Betslip-module--header--5ac9f";
export var hidden = "Betslip-module--hidden--2f673";
export var icon = "Betslip-module--icon--04851";
export var iconButton = "Betslip-module--iconButton--77546";
export var info = "Betslip-module--info--1a7c6";
export var isReviewing = "Betslip-module--isReviewing--c482d";
export var label = "Betslip-module--label--6a0a5";
export var largeFooter = "Betslip-module--largeFooter--6f511";
export var marketName = "Betslip-module--marketName--aabba";
export var outcomeIcon = "Betslip-module--outcomeIcon--bb2a5";
export var panel = "Betslip-module--panel--3fc2f";
export var quickBalance = "Betslip-module--quickBalance--5a8a8";
export var reuseBetsButton = "Betslip-module--reuseBetsButton--21579";
export var right = "Betslip-module--right--ae101";
export var scrollArea = "Betslip-module--scrollArea--9fef9";
export var selectionName = "Betslip-module--selectionName--98643";
export var small = "Betslip-module--small--6931d";
export var smallFooter = "Betslip-module--smallFooter--c565d";
export var tab = "Betslip-module--tab--27bda";
export var tabList = "Betslip-module--tabList--19c4e";
export var tabListContainer = "Betslip-module--tabListContainer--5697d";
export var tabs = "Betslip-module--tabs--6f2b6";
export var title = "Betslip-module--title--94de3";
export var trash = "Betslip-module--trash--967ab";
export var value = "Betslip-module--value--f10f9";